function capitalize(str) {
  return str.replace(str[0], str[0].toUpperCase());
}

export { capitalize };
//# sourceMappingURL=capitalize.js.map
